module.exports = __webpack_public_path__ + "static/img/bottom_bg@2x.c0acb657.png";